/**
 * NESTY BLOOM — Hero Slider
 * Slider vanilla JS (sin librerías externas).
 *
 * FASE 1 — Autoplay reforzado:
 * - Arranca solo, con la velocidad configurada en el Theme Editor (por
 *   defecto 5s si el ajuste no llega por algún motivo).
 * - Se pausa al usar flechas/indicadores y se reanuda unos segundos después.
 * - Blindado contra valores inválidos (NaN, 0, etc.) y contra un doble
 *   arranque si el navegador dispara varias veces los eventos de carga.
 */
(function () {
  'use strict';

  var RESUME_DELAY = 5000;     // ms antes de reanudar el autoplay tras interacción manual
  var MIN_AUTOPLAY_MS = 1500;  // piso de seguridad para evitar loops demasiado rápidos

  function NBHeroSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.nb-hero-slider__slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.nb-hero-slider__dot'));
    this.prevBtn = root.querySelector('.nb-hero-slider__arrow--prev');
    this.nextBtn = root.querySelector('.nb-hero-slider__arrow--next');

    this.autoplay = root.getAttribute('data-autoplay') === 'true';

    var parsedSpeed = parseFloat(root.getAttribute('data-speed'));
    if (!parsedSpeed || isNaN(parsedSpeed) || parsedSpeed <= 0) parsedSpeed = 5; // por defecto 5s
    this.speed = Math.max(parsedSpeed * 1000, MIN_AUTOPLAY_MS);

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.current = 0;
    this.timer = null;
    this.resumeTimeout = null;

    if (this.slides.length <= 1) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      var dotsWrap = root.querySelector('.nb-hero-slider__dots');
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    this.bindEvents();
    this.goTo(0, true);

    if (this.autoplay && !this.reducedMotion) this.play();
  }

  NBHeroSlider.prototype.bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.goTo(self.current - 1);
        self.handleInteraction();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.goTo(self.current + 1);
        self.handleInteraction();
      });
    }

    this.dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        self.goTo(index);
        self.handleInteraction();
      });
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.goTo(self.current - 1); self.handleInteraction(); }
      if (e.key === 'ArrowRight') { self.goTo(self.current + 1); self.handleInteraction(); }
    });

    this.root.addEventListener('mouseenter', function () { self.pause(); });
    this.root.addEventListener('mouseleave', function () { self.scheduleResume(); });
    this.root.addEventListener('focusin', function () { self.pause(); });
    this.root.addEventListener('focusout', function () { self.scheduleResume(); });

    var touchStartX = 0;
    var touchEndX = 0;
    this.root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      self.pause();
    }, { passive: true });

    this.root.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) self.goTo(self.current + 1);
        else self.goTo(self.current - 1);
      }
      self.scheduleResume();
    }, { passive: true });

    document.addEventListener('shopify:block:select', function (e) {
      if (!self.root.contains(e.target)) return;
      var index = self.slides.indexOf(e.target.closest('.nb-hero-slider__slide'));
      if (index > -1) { self.pause(); self.goTo(index); }
    });

    document.addEventListener('shopify:block:deselect', function () {
      if (self.autoplay && !self.reducedMotion) self.play();
    });
  };

  NBHeroSlider.prototype.goTo = function (index, immediate) {
    var total = this.slides.length;
    var next = (index + total) % total;

    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].classList.remove('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'false');

    this.current = next;

    this.slides[this.current].classList.add('is-active');
    this.dots[this.current] && this.dots[this.current].classList.add('is-active');
    this.dots[this.current] && this.dots[this.current].setAttribute('aria-selected', 'true');

    if (!immediate) this.restartAutoplayCycle();
  };

  NBHeroSlider.prototype.play = function () {
    var self = this;
    this.clearTimer();
    if (!this.autoplay || this.reducedMotion) return;
    this.timer = setInterval(function () { self.goTo(self.current + 1, true); }, this.speed);
  };

  NBHeroSlider.prototype.pause = function () {
    this.clearTimer();
    if (this.resumeTimeout) { clearTimeout(this.resumeTimeout); this.resumeTimeout = null; }
  };

  NBHeroSlider.prototype.clearTimer = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  NBHeroSlider.prototype.restartAutoplayCycle = function () {
    if (this.autoplay && this.timer && !this.reducedMotion) this.play();
  };

  NBHeroSlider.prototype.handleInteraction = function () {
    this.scheduleResume();
  };

  NBHeroSlider.prototype.scheduleResume = function () {
    var self = this;
    this.clearTimer();
    if (this.resumeTimeout) clearTimeout(this.resumeTimeout);
    if (!this.autoplay || this.reducedMotion) return;
    this.resumeTimeout = setTimeout(function () {
      self.resumeTimeout = null;
      self.play();
    }, RESUME_DELAY);
  };

  function initAll(scope) {
    var context = scope || document;
    var sliders = context.querySelectorAll('.nb-hero-slider[data-nbhs-init="false"]');
    sliders.forEach(function (el) {
      el.setAttribute('data-nbhs-init', 'true');
      new NBHeroSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
